import React from 'react';
import { css } from 'aphrodite';
import styles from './styles';

export type ViewMoreRowProps = {
  depth: number;
  onLoadMore: () => void;
  isLoading: boolean;
};

const ViewMoreRow = ({ depth, onLoadMore, isLoading }: ViewMoreRowProps) => {
  const handleLoadMore = () => {
    if (!isLoading) {
      onLoadMore();
    }
  };

  return (
    <div
      className={css(styles.tableRow, styles.viewMoreRow)}
      style={{
        paddingLeft: `${20 + depth * 24}px`,
        paddingRight: '20px',
      }}
      onClick={handleLoadMore}
      role="button"
      tabIndex={0}
      aria-label={isLoading ? 'Loading more folders...' : 'Load more folders'}
    >
      <div className={css(styles.viewMoreRowContent)}>
        {/* Empty space to align with the expand icon column */}
        <div className={css(styles.viewMoreIconSpace)} />

        <div className={css(styles.viewMoreTextContainer)}>
          {isLoading ? (
            <span className={css(styles.viewMoreText, styles.loadingText)}>
              Loading...
            </span>
          ) : (
            <span className={css(styles.viewMoreText)}>
              View more subfolders
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewMoreRow;
